// List query for all wind sessions (active + history). Polls every 5s.
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";
import type { WindSessionWithLatest } from "@/types/api";

export interface WindListResponse {
  active_sessions: WindSessionWithLatest[];
  history_sessions: WindSessionWithLatest[];
  summary?: { total_pnl?: number };
}

export function useWindSessions() {
  return useQuery<WindListResponse>({
    queryKey: ["wind"],
    queryFn: () => apiGet<WindListResponse>("/wind"),
    // SSE pushes wind events; 30s safety net.
    refetchInterval: 30_000,
  });
}
